export default "__VITE_PUBLIC_ASSET__244052c4__"